import { serverInfo } from "../config/serverConfig";
import { checkResponse } from "../utils/apiError";
import { stockRequestBody } from "./stockContext";


import { apiFetch } from "./apiFetch";

/**
 * Bulk update sector, industry, and/or equity across many stock holdings.
 * Body: { account_id, user_id?, role?, _ids, sector?, industry?, equity? }
 * Returns { matched, modified }.
 */
export async function bulkUpdateStocks(session, payload) {
  const resp = await apiFetch(serverInfo.serverUrl + "/bulkUpdateStocks", {
    method: "POST",
    body: JSON.stringify(stockRequestBody(session, payload)),
  });
  checkResponse(resp);
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || "Bulk update failed");
  }
  return resp.json();
}
